export var OrganisationHeirarchyType;
(function (OrganisationHeirarchyType) {
    OrganisationHeirarchyType["Parent"] = "parent";
    OrganisationHeirarchyType["Child"] = "child";
})(OrganisationHeirarchyType || (OrganisationHeirarchyType = {}));
//# sourceMappingURL=schema.js.map